import { Alert, Box, Stack, Typography } from "@mui/material";
import React from "react";
import { EmailMarketingIcon, SmsIcon } from "../../assets/constants";
import CallIcon from "../../icons/CallIcon";
import { LoadingButton } from "@mui/lab";
import AppContactDetailCard from "../AppContactDetailCard";
import MobileAppActionButtons from "../MobileAppActionButtons";

const PendingIconContent = ({
  is_enrolled,
  patientName,
  patientId,
  patientContactNumber,
  patientEmail,
  subtitle,
  resendCredentialsHandler,
  openChangePasswordModalHandler,
  isDisabled = false,
}) => {
  return (
    <Stack gap="24px">
      {!isDisabled && (
        <MobileAppActionButtons
          resendCredentialsHandler={resendCredentialsHandler}
          openChangePasswordModalHandler={openChangePasswordModalHandler}
        />
      )}

      {is_enrolled ? (
        <>
          {" "}
          <Alert severity="warning">{subtitle}</Alert>
          <AppContactDetailCard
            status="pending"
            patientId={patientId}
            patientContactNumber={patientContactNumber}
            patientEmail={patientEmail}
          />
        </>
      ) : (
        <>
          <Alert severity="warning">{subtitle}</Alert>

          <AppContactDetailCard
            patientId={patientId}
            patientContactNumber={patientContactNumber}
            patientEmail={patientEmail}
            status="inactive"
          />
        </>
      )}
    </Stack>
  );
};

export default PendingIconContent;
